import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { ContactType } from "@/gql/graphql";
import { Contact } from "@/gql/schema";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { BillingCycleDateInput } from "@/app/Contacts/Components/BillingCycleDateInput";

export function ContactDetailsForm({
  contact,
}: {
  contact?: Pick<Contact, "type">;
}) {
  return (
    <>
      <TextInput
        name={"name"}
        label={"Name"}
        isEditable={
          contact
            ? ![
                ContactType.User,
                ContactType.Organisation,
                ContactType.System,
              ].includes(contact.type)
            : true
        }
      />

      <FormDivider />
      <TextInput
        name={"legal_name"}
        label={"Legal name"}
        tooltip="Used on formal documents"
      />
      <TextInput
        name={"company_number"}
        label={"Business number"}
        optionalLabel
      />
      <TextInput
        name={"purchase_order_number"}
        label={"Default Purchase Order #"}
        optionalLabel
      />

      <TextInput
        name={"billing_email"}
        label={"Billing email"}
        type="email"
        optionalLabel
      />
      <TextInput name={"billing_phone"} label={"Billing phone"} optionalLabel />

      <BillingCycleDateInput
        label="Invoice cycle date"
        name="billing_cycle_day_of_month"
      />
    </>
  );
}
